export default __webpack_public_path__ + "static/media/discount-shape.fcfef66b.svg";